import script from "./StackedTextSection.vue?vue&type=script&setup=true&lang=js"
export * from "./StackedTextSection.vue?vue&type=script&setup=true&lang=js"

import "./StackedTextSection.vue?vue&type=style&index=0&id=66d64e0d&lang=scss&scoped=true"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66d64e0d"]])

export default __exports__